import React from 'react'
import { useTranslation } from 'react-i18next';
// ANT COMPONENTS
import { Button } from '@life-line-lab/components-react';
import { DriverApprovalStatus, DriverStatus } from 'Types/new_driver_types';

interface TabContentFooterProps {
    canEdit?:boolean;
    canDelete?:boolean;
    handleEdit?:()=>void;
    handleActivate?:(action:string)=>void;
    handleSetModal?:(action:string)=>void;
    driverDetails:any;
}

const TabContentFooter:React.FC<TabContentFooterProps> = ({
    canEdit,
    canDelete,
    handleEdit,
    handleActivate,
    handleSetModal,
    driverDetails,
}) => {

    const { t } = useTranslation();

    const renderFromDriverStatus = () => {
      switch (driverDetails.status) {
        case "DEACTIVATED":
          if (driverDetails.approvalStatus === DriverApprovalStatus.REJECTED) {
            return (
              <>
                {canEdit && (
                  <Button
                    type="success"
                    className="mr-10"
                    label={t("action.approve")}
                    onClick={() => {
                      handleSetModal &&
                        handleSetModal(DriverApprovalStatus.APPROVED);
                    }}
                  />
                )}
              </>
            );
          } else {
            return (
              <>
                {canEdit && (
                  <Button
                    type="primary"
                    className="mr-10"
                    label={t("action.activate")}
                    onClick={() => {
                      // handleActivate && handleActivate(DriverStatus.ACTIVATE)
                      handleSetModal && handleSetModal(DriverStatus.ACTIVATE);
                    }}
                  />
                )}
              </>
            );
          }

        case "ACTIVE":
          return (
            <>
              {canEdit && (
                <Button
                  type="primary"
                  className="mr-10"
                  label={t("action.edit")}
                  onClick={() => {
                    handleEdit && handleEdit();
                  }}
                />
              )}
              {canDelete && (
                <Button
                  type="danger"
                  label={t("action.deactivate")}
                  onClick={() =>
                    handleSetModal && handleSetModal(DriverStatus.DEACTIVATE)
                  }
                />
              )}
            </>
          );

        case "PENDING_ACCOUNT":
          if (
            driverDetails.approvalStatus === DriverApprovalStatus.UNAPPROVED &&
            canEdit
          ) {
            return (
              <>
                <Button
                  type="success"
                  className="mr-10"
                  label={t("action.approve")}
                  onClick={() => {
                    handleSetModal &&
                      handleSetModal(DriverApprovalStatus.APPROVED);
                  }}
                />
                <Button
                  type="danger"
                  className="mr-10"
                  label={t("action.reject")}
                  onClick={() => {
                    handleSetModal &&
                      handleSetModal(DriverApprovalStatus.REJECTED);
                  }}
                />
              </>
            );
          } else if (
            driverDetails.approvalStatus === DriverApprovalStatus.PENDING
          ) {
            return (
              <>
                {canEdit && (
                  <Button
                    type="primary"
                    className="mr-10"
                    label={t("action.edit")}
                    onClick={() => {
                      handleEdit && handleEdit();
                    }}
                  />
                )}
                {canDelete && (
                  <Button
                    type="danger"
                    label={t("action.deactivate")}
                    onClick={() =>
                      handleSetModal && handleSetModal(DriverStatus.DEACTIVATE)
                    }
                  />
                )}
              </>
            );
          } else {
            return null;
          }

        default:
          return null;
      }
    };

    return (
      <div className="right mt-50">
        {renderFromDriverStatus()}
      </div>
    )
}

export default TabContentFooter